<h2 class="mat-h2">Server params</h2>
<mat-table [dataSource]="serverParams$ | async">
  <ng-container matColumnDef="key">
    <mat-header-cell *matHeaderCellDef> key</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.key }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="value">
    <mat-header-cell *matHeaderCellDef> value</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.value }}</mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columns"></mat-row>
</mat-table>
<form [formGroup]="formData" (submit)="setServerParam()">
  <mat-form-field>
    <mat-label>key</mat-label>
    <input matInput formControlName="key">
  </mat-form-field>
  <mat-form-field>
    <mat-label>value</mat-label>
    <input matInput formControlName="value">
  </mat-form-field>
  <button mat-stroked-button type="submit">Set</button>
</form>
